var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProperties(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.4609 53.4675H55.4609V61.0252H51.4609V53.4675Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3984 53.4675H19.3984V61.0271H15.3984V53.4675Z",
    fill: "#2D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3984 72.3665H19.3984V79.9242H15.3984V72.3665Z",
    fill: "#2D2943"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8945 72.3665H37.8945V79.9242H33.8945V72.3665Z",
    fill: "#2D2943"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8945 53.4675H37.8945V61.0271H33.8945V53.4675Z",
    fill: "#2D2943"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3984 35.5137H19.3984V43.0732H15.3984V35.5137Z",
    fill: "#2D2943"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8945 35.5137H37.8945V43.0732H33.8945V35.5137Z",
    fill: "#2D2943"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.332 53.4675H69.332V61.0252H65.332V53.4675Z",
    fill: "#2D2943"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1289 53.4675H84.1289V61.0252H80.1289V53.4675Z",
    fill: "#2D2943"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.332 72.3665H69.332V79.9242H65.332V72.3665Z",
    fill: "#2D2943"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1289 72.3665H84.1289V79.9242H80.1289V72.3665Z",
    fill: "#2D2943"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4609 72.3665H55.4609V79.9242H51.4609V72.3665Z",
    fill: "#2D2943"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.434 46.7076H46.6331V86.6861H89.434V46.7076ZM43.0664 43.0732V90.3205H93.0007V43.0732H43.0664Z",
    fill: "#2D2943"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1478 28.8907L26.8813 14.8086L10.6148 28.8907V86.6694H43.1478V28.8907ZM26.8813 10L46.7625 27.2115V90.3203H7V27.2115L26.8813 10Z",
    fill: "#2D2943"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2692 13.7798L28.2692 86.5405L24.5703 86.5405L24.5703 13.7798L28.2692 13.7798Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperties);
export default __webpack_public_path__ + "static/media/properties.ec93ffe9.svg";
export { ForwardRef as ReactComponent };